import {createContext} from "react";

export const DashboardContext = createContext(null);
export const DashboardCtxDefault = {
  advertiser: null,
  setAdvertiser: () => {},
};
